import { xor } from './utils/xor';
import { SearchScopeKind } from 'owa-search-service';
import { getSelectedTableView, TableQueryType } from 'owa-mail-list-store';
import { getStore as getMailSearchStore } from 'owa-mail-search';
import getStaticSearchScope from 'owa-mail-search-next-lazy/lib/selectors/getStaticSearchScope';
import { isFeatureEnabled } from 'owa-feature-flags';

export const searchScopeRestriction = (
    searchScopes: SearchScopeKind[],
    shouldHide?: boolean
) => () => {
    const {
        tableQuery: { type },
    } = getSelectedTableView();
    if (type !== TableQueryType.Search) {
        return true;
    }
    const staticSearchScope = isFeatureEnabled('sea-lazy2')
        ? getStaticSearchScope()
        : getMailSearchStore().staticSearchScope;
    const isCurrentSearchScopeInRestriction =
        staticSearchScope && searchScopes.includes(staticSearchScope.kind);
    return xor(shouldHide, isCurrentSearchScopeInRestriction);
};
